import React from "react";
import TranslateManager from 'ts-translate-js';
import './become-member-buttons.scss';
import { MembershipTypeSaleInfoModel } from "../../../tsrestapi/models";

const tr = TranslateManager.boundTR;

type BecomeMemberButtonsProps = {
    membershipType: MembershipTypeSaleInfoModel;
    onAlreadyMemberClick: (membershipType: MembershipTypeSaleInfoModel) => void;
    onBecomeMemberClick: (membershipType: MembershipTypeSaleInfoModel) => void;
};

export function BecomeMemberButtons({membershipType, onAlreadyMemberClick, onBecomeMemberClick}: BecomeMemberButtonsProps) {
    return <div className="become-member-buttons">
        <div>
            <button type='button' onClick={() => onAlreadyMemberClick(membershipType)} className='btn btn-primary'>{tr("Je suis membre")}</button>
        </div>
        <div>
            <button type='button' onClick={() => onBecomeMemberClick(membershipType)} className='btn btn-default'>{tr("Devenir membre")}</button>
        </div>
    </div>;
}